import { apiGet, apiSend } from '@/lib/api/client';

export interface MaintenanceSettings {
  enabled: boolean;
  title: string;
  message: string;
  updatedAt: string;
}

export interface SystemSettings {
  maintenance: MaintenanceSettings;
}

export const defaultSystemSettings: SystemSettings = {
  maintenance: {
    enabled: false,
    title: 'Scheduled Maintenance',
    message: "Stingray is temporarily offline while we complete a short maintenance window. We'll be back online shortly.",
    updatedAt: '',
  },
};

export function getSystemSettings() {
  return apiGet<SystemSettings>('/system-settings.php');
}

export function updateSystemSettings(maintenance: Partial<MaintenanceSettings>) {
  return apiSend<SystemSettings>('/admin/system-settings.php', 'PATCH', {
    maintenance,
  });
}
